/**
 * BypassGo logo component.
 * - variant="full"    : symbol "B" + wordmark "BypassGo" + tagline
 * - variant="compact" : symbol "B" + wordmark (no tagline)
 * - variant="symbol"  : symbol "B" only (square, ideal for avatars / favicons / mobile bottom nav)
 *
 * The actual rendering uses static PNG assets shipped in /public.
 * Falls back to a CSS rendering if the image fails to load (resilience).
 */
export function Logo({ variant = "full", className = "", height, alt = "BypassGo", "data-testid": testId = "bypassgo-logo" }) {
  const src = variant === "symbol"
    ? "/logo-bypassgo-b-only.png"
    : variant === "compact"
      ? "/logo-bypassgo-compact.png"
      : "/logo-bypassgo-full.png";
  const defaultH = variant === "symbol" ? 32 : variant === "compact" ? 36 : 56;
  const h = height || defaultH;
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{ height: h, width: "auto", display: "block" }}
      data-testid={testId}
      draggable={false}
    />
  );
}

export default Logo;
